import { createSelector } from '@reduxjs/toolkit';
import { getState } from '@yme/selectors/common';
const getFasletState = createSelector(getState, (state) => state.faslet);
export const getIsItemAddedToCart = createSelector(getFasletState, (faslet) => faslet.isItemAddedToCart);
export const getIsFasletToCartAnalyticTrigger = createSelector(getFasletState, (faslet) => faslet.isFasletAnalyticTriggered);
export const getIsWidgetShown = createSelector(getFasletState, (faslet) => faslet.isWidgetShown);
export const getFasletShoppingId = createSelector(getFasletState, (faslet) => faslet.fasletShoppingId);
export const getFasletOrderTrackingData = createSelector(getFasletState, (faslet) => faslet.orderTrackingData);
